import { Notice } from "../components/ui/Notice";
import { Panel, SectionTitle } from "../components/ui/Panel";
import { Tag } from "../components/ui/Tag";
import { ParamForm } from "../components/data/ParamForm";
import { DEFAULT_PETTOWN, PETTOWN_GROUPS, type PettownParams } from "../lib/params";
import { useT } from "../lib/i18n";
import { PETTOWN_LENS } from "../lib/apiLensIds";

/**
 * 萌宠小镇的全局参数（累计星数上限、一星几格、修复费比例、破坏者收益比例、对抗匹配两项）。
 *
 * **体系选择不在这一页**，在「初始化配置」里跟玩法体系一起选。原来这两件事各在一页，
 * 结果切了体系之后两页各说各话（一页说萌宠小镇、另一页的选择器还停在关卡制），
 * 而且左侧菜单两套配置一起挂着——运营根本分不清哪一组是活的。
 *
 * 这一页只在体系 = 萌宠小镇时出现在菜单里（nav.ts 按体系过滤）。
 * 造价一颗星一个数，在「主建筑星级表」里配；这里没有任何按星分组的东西（leo 2026-09-17：星是唯一单位）。
 */
export function PettownParamsPage({
  system, pettown, editable, onPettown, onGotoInit,
}: {
  /** 当前版本的体系；不是 pettown 时这一页的参数没有意义，只读展示并指路 */
  system: string;
  pettown: PettownParams;
  editable: boolean;
  onPettown: (v: PettownParams) => void;
  onGotoInit: () => void;
}) {
  const t = useT();
  const on = system === "pettown";
  const can = editable && on;
  return (
    <div>
      <Panel>
        <SectionTitle extra={<Tag tone={on ? "success" : "danger"}>{on ? "pettown" : system || t("ptx.params.noSystem")}</Tag>}>
          {t("nav.pettown-params")}
        </SectionTitle>
        {on
          ? <Notice tone="info">{t("pt.params.note")}</Notice>
          : (
            <Notice tone="warning">
              {t("pt.params.wrongSystem")}
              <button type="button" className="ml-2 underline" onClick={onGotoInit}>{t("pt.params.goInit")}</button>
            </Notice>
          )}
      </Panel>
      <div className={on ? "mt-4" : "mt-4 opacity-45"}>
        <ParamForm groups={PETTOWN_GROUPS} value={pettown} editable={can} onSave={onPettown} defaults={DEFAULT_PETTOWN} api={PETTOWN_LENS} />
      </div>
    </div>
  );
}
